import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import React from 'react'

function SuminsuredListHeaderDetails({sumInsuredData}) { 
  const headersWithDescription = sumInsuredData?.sumInsuredHeaderSorted?.filter(
    (header) => header.description?.trim()
  );

  if (!headersWithDescription || headersWithDescription.length === 0) return null;

  return (
    <TableContainer  sx={{ mt: 2 }}>
     
      <Table size="small">
      
        <TableBody>
          {headersWithDescription.map((header) => (
            <TableRow key={header.id}>
              <TableCell style={{paddingLeft:'0px'}}><span style={{fontWeight:'bold'}}>* {header.title} :</span> {header.description}</TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SuminsuredListHeaderDetails